<template>
  <div class="content-box">
    <fieldset v-for="(passport, i) in passports" :key="i">
      <v-row>
        <v-col cols="4"><p class="label">Connection ID</p></v-col>
        <v-col cols="8"><v-text-field :value="passport.connectionidhex" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <v-col cols="4"><p class="label">Passport session</p></v-col>
        <v-col cols="8"><v-text-field :value="passport.rootcontextidhex" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <v-col cols="4"><p class="label">Action type</p></v-col>
        <v-col cols="8"><v-text-field :value="passport.actiontype" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <v-col cols="4"><p class="label">Action</p></v-col>
        <v-col cols="8"><v-text-field :value="passport.action" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <v-col cols="4"><p class="label">Service</p></v-col>
        <v-col cols="8"><v-text-field :value="passport.service" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <v-col cols="4"><p class="label">Trace flag</p></v-col>
        <v-col cols="8"><v-text-field :value="passport.trraceflag" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <v-col cols="4"><p class="label">Source system name</p></v-col>
        <v-col cols="8"><v-text-field :value="passport.compname" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
      <v-row>
        <v-col cols="4"><p class="label">Previous system name</p></v-col>
        <v-col cols="8"><v-text-field :value="passport.prevcompname" outlined dense hide-details readonly></v-text-field></v-col>
      </v-row>
    </fieldset>
  </div>
</template>

<script>
import { api } from '../../../api/common/instances';
import tabable from './tabable';

export default {
  mixins: [tabable],
  data() {
    return {
      passports: [],
    };
  },
  methods: {
    async fetch(params) {
      // eslint-disable-next-line prettier/prettier
      ({ data: this.passports } = await api.get('/analysis/dsrviewer/detail/passport', { params }));
      this.increaseLoadingCount();
    },
  },
};
</script>

<style lang="scss" scoped>
.content-box {
  padding: 0px;
}
fieldset {
  margin-top: 10px;
  padding: 10px;
  border-width: 1px;
}
fieldset legend {
  padding: 0px 10px;
}
.label {
  text-align: right;
  padding-right: 15px;
}
.v-text-field {
  width: 100%;
}
</style>
